$(document).ready(function(){
  
  $(".banner_slider .banner_list").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 3000,
    slidesToShow: 1,
    adaptiveHeight: true,
  });
  
  $(".reviews_inner .customer_list").slick({
    dots: false,
    infinite: true,
    arrows: true,
     speed: 300,
    slidesToShow: 1,
  });
  
  $('.new_featured_collection .product-list').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.customer_reviews_section .reviews_list').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
    /*===================================*
     SEARCH BAR 
    *===================================*/
  	// document.querySelector('.openBtn').addEventListener("click",()=>{openSearch("#myOverlay")})
  	// 	document.querySelector('.closebtn').addEventListener("click",()=>{closeSearch("#myOverlay")})
  		
  	// 		document.querySelector('.openBtn-mobile').addEventListener("click",()=>{openSearch("#myOverlay2")})
  	// 	document.querySelector('.closebtn-mobile').addEventListener("click",()=>{closeSearch("#myOverlay2")})
  
   //      function openSearch(args)
   //      {
        
   //      	document.querySelector(`${args}`).style.display="block"
        	
   //      }
   //      function closeSearch(args2)
   //      {
        	
   //      	document.querySelector(`${args2}`).style.display="none"
        	
   //      }
  
});